import { render, staticRenderFns } from "./AreaAdscripcionComponent.vue?vue&type=template&id=55887222&scoped=true"
import script from "./AreaAdscripcionComponent.vue?vue&type=script&lang=js"
export * from "./AreaAdscripcionComponent.vue?vue&type=script&lang=js"
import style0 from "./AreaAdscripcionComponent.vue?vue&type=style&index=0&id=55887222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55887222",
  null
  
)

export default component.exports